export enum Edition {
    TRIAL = 'Keap Pro Free Trial',
    LITE = 'Keap Lite Edition',
    PRO = 'Keap Pro Edition',
    MAX = 'Keap Max Edition',
    ULTIMATE = 'Keap Max Classic Edition',
}
